export default {"src":"/_next/static/media/floor-plan.b79da2d2.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};